
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[title]",
      function () {
        return require("private-next-pages/articles/[title].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[title]"])
      });
    }
  